import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/Logo";
import { useT } from "@/i18n";

export function Footer() {
  const t = useT();
  return (
    <footer className="border-t border-border bg-secondary/40">
      <div className="container-page grid gap-10 py-14 md:grid-cols-[1.4fr_1fr_1fr]">
        <div className="space-y-3">
          <Logo />
          <p className="max-w-sm text-sm text-muted-foreground">
            {t("foot.tagline")}
          </p>
        </div>
        <div className="space-y-2">
          <p className="text-sm font-semibold text-foreground">{t("foot.discover")}</p>
          <Link to="/marketplace" className="block text-sm text-muted-foreground hover:text-foreground">{t("nav.marketplace")}</Link>
          <Link to="/coaches" className="block text-sm text-muted-foreground hover:text-foreground">{t("nav.coaches")}</Link>
          <Link to="/signup" className="block text-sm text-muted-foreground hover:text-foreground">{t("foot.create_account")}</Link>
        </div>
        <div className="space-y-2">
          <p className="text-sm font-semibold text-foreground">{t("foot.legal")}</p>
          <a href="https://my-within.com/privacy" className="block text-sm text-muted-foreground hover:text-foreground">{t("foot.privacy")}</a>
          <a href="https://my-within.com/terms" className="block text-sm text-muted-foreground hover:text-foreground">{t("foot.terms")}</a>
          <a href="mailto:support@my-within.com" className="block text-sm text-muted-foreground hover:text-foreground">{t("support")}</a>
        </div>
      </div>
      <div className="border-t border-border/70">
        <div className="container-page flex flex-col items-center justify-between gap-2 py-5 text-xs text-muted-foreground sm:flex-row">
          <p>© {new Date().getFullYear()} My Within · Inside Out Harmony e.U.</p>
          <p>{t("foot.built_in_austria")}</p>
        </div>
      </div>
    </footer>
  );
}
